import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, PropertyValueMap, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ColorVersionStepDto, SelectMode } from '@/api-sdk';
import { isScrolledIntoView, scrollStepIntoView } from '@/utils';

import '../fg-configurator-step';
import './color-version/fg-color-option';
import './color-version/fg-version-option';
import './color-version/fg-version-options-list';

@customElement('fg-configurator-step-color-version')
@localized()
export class FgConfiguratorStepColorVersion extends LitElement {
  @property({ type: Array })
  colorOptions: ColorVersionStepDto['colors'] = [];

  @property({ type: Array })
  versionOptions: ColorVersionStepDto['versions'] = [];

  @property({ type: String })
  selectMode: SelectMode = SelectMode.SINGLE;

  @property({ type: String })
  selectModeSwitchQueryString: ColorVersionStepDto['selectModeSwitchQueryString'] =
    '';

  @property({ type: String })
  validationMessage?: string | null = null;

  @property({ type: Boolean })
  showValidationMessage = false;

  @property({ type: Boolean })
  scrollToStep = false;

  render() {
    return html`
      <fg-configurator-step-color
        .stepTitle=${t('headers.chooseColor') || ''}
        .colorOptions=${this.colorOptions}
        .selectMode=${this.selectMode}
        .selectModeSwitchQueryString=${this.selectModeSwitchQueryString}
        .validationMessage=${this.validationMessage}
        .showValidationMessage=${this.showValidationMessage}
      ></fg-configurator-step-color>

      <fg-version-options-list
        .stepTitle="${t('headers.chooseVersion') || ''}"
        .options=${this.versionOptions}
      ></fg-version-options-list>
    `;
  }

  protected willUpdate(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    if (_changedProperties.has('scrollToStep') && this.scrollToStep) {
      scrollStepIntoView(this);

      isScrolledIntoView(this);
    }
  }

  static styles = css`
    fg-configurator-step-color {
      scroll-margin-top: 100px;
    }
    fg-version-options-list {
      display: block;
      margin-top: 20px;
    }
  `;
}
